exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jqx-widget-header[data-v-6fafd26c]{border-color:transparent!important}.jqx-fill-state-hover[data-v-6fafd26c],.jqx-fill-state-pressed[data-v-6fafd26c],.jqx-menu-item-top-hover[data-v-6fafd26c],.jqx-widget-header[data-v-6fafd26c]{background:transparent!important}.jqx-menu-item-top-hover[data-v-6fafd26c]{border-color:transparent!important}", ""]);

// exports
